import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: auto;

  ul {
    display: flex;
    list-style-type: none;
    align-items: center;
    gap: 0.5rem;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      min-width: 32px;
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.2s;

      a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        color: #b5b3b3;
        padding: 0 8px;
        @media ${MOBILE_WIDTH} {
          font-size: 14px;
        }
      }
    }

    li.selected {
      background: transparent;
      a {
        color: #898483;
        font-weight: 500;
      }
    }

    li.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    li.next,
    li.previous {
      display: flex;
      background-color: transparent;
      border: none;

      button {
        border: none !important;
        background: transparent !important;
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      svg {
        font-size: 16px;
        color: #b5b3b3;
        @media ${MOBILE_WIDTH} {
          font-size: 14px;
        }
      }

      &:hover:not(.disabled) {
        svg {
          color: #898483;
        }
      }
    }

    li.break {
      a {
        color: #b5b3b3;
        font-size: 16px;
        padding: 0 4px;
      }
    }
  }
`
